import { useSelector } from "react-redux";
import { useUrl } from "@twire/utility/hooks";
import { RootReducer } from "@twire/redux/types";
import { t } from "@twire/utility/helpers";

import { TournamentsNavItem } from "./types";
import { TournamentsViewProps } from "../TournamentsView";

export type NavLinksType = TournamentsNavItem[];

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTournamentsNavLinks = ({
  mode = "tournament"
}: {
  mode?: TournamentsViewProps["mode"];
}) => {
  const {
    app: { game }
  } = useSelector((state: RootReducer) => state);

  const navLinksMode = {
    ppt: [
      {
        url: useUrl(`/${game}/ppt/ppt_scrim`),
        title: t("words.pptScrims")
      },
      {
        url: useUrl(`/${game}/ppt/ppt_cup`),
        title: t("words.pptCups")
      },
      {
        url: useUrl(`/${game}/ppt/ppt_master`),
        title: t("words.pptMasters")
      }
    ],
    tournament: [
      {
        url: useUrl(`/${game}/tournaments/ongoing`),
        title: t("words.ongoingTournaments")
      },
      {
        url: useUrl(`/${game}/tournaments/past`),
        title: t("words.pastTournaments")
      },
      {
        url: useUrl(`/${game}/tournaments/upcoming`),
        title: t("words.upcomingTournaments")
      }
    ],
    scrim: []
  };
  const navLinks: TournamentsNavItem[] = navLinksMode[mode];
  return {
    navLinks
  };
};
